import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

const FeatureDisabledTooltip = ({target, msg}) => {
  return (
    <UncontrolledTooltip placement="bottom" target={target}>{msg}</UncontrolledTooltip>
  );
};

export default FeatureDisabledTooltip;